export enum PastMedicalHistory {
    ADHD = "ADHD",
    anemia = "Anemia/iron deficiency",
    aneurysm = "Aneurysm",
    angina = "Angina",
    anxiety = "Anxiety",
    arrhythmia = "Arrhythmia",
    arthritis = "Arthritis",
    ascites = "Ascites",
    ascvd = "ASCVD",
    asthma = "Asthma",
    afib = "Atrial fibrillation",
    breastAugmentation = "Breast augmentation",
    bipolarDisorder = "Bipolar disorder",
    cad = "CAD",
    cancer = "Cancer/Metastatic",
    cardiomegaly = "Cardiomegaly",
    cardiomyopathy = "Cardiomyopathy",
    cataractWOSx = "Cataract w/o Sx",
    cataractWSx = "Cataract w/ Sx",
    cellulitis = "Cellulitis",
    cerebralPalsy = "Cerebral palsy",
    chemotherapy = "Chemotherapy",
    chf = "CHF",
    chronicPain = "Chronic pain",
    cirrhosis = "Cirrhosis",
    colitis = "Colitis",
    copd = "COPD",
    crohnsDisease = "Crohn's disease",
    cushingsDisease = "Cushing's disease",
    cva = "CVA",
    cysticFibrosis = "Cystic Fibrosis",
    decubitus = "Decubitus",
    sbo = "Small bowel obstruction",
    sob = "SOB",
    substanceAbuse = "Substance abuse",
    tbi = "Traumatic brain injury",
    depression = "Depression",
    digoxinToxicity = "Digoxin toxicity",
    diverticulitis = "Diverticulitis",
    djd = "DJD",
    dm = "DM",
    downsSyndrome = "Down's Syndrome",
    dvt = "DVT",
    epilepsy = "Epilepsy",
    emphysema = "Emphysema",
    encephalopathy = "Encephalopathy 2'",
    endocarditis = "Endocarditis",
    esophagealVarices = "Esophageal varices",
    fibromyalgia = "Fibromyalgia",
    gerd = "GERD",
    giBleed = "GI Bleed",
    glaucoma = "Glaucoma",
    gout = "Gout",
    gravesDisease = "Graves disease",
    gbs = "Guillain-Barre Syndrome",
    headaches = "Headaches",
    hemiparesis = "Hemiparesis",
    hemodialysis = "Hemodialysis",
    htn = "HTN",
    huntingtonsDisease = "Huntington's disease",
    hyperlipidemia = "Hyperlipidemia",
    hyperthyroidism = "Hyperthyroidism",
    hypothyroidism = "Hypothyroidism",
    ibs = "IBS",
    icbIchSah = "ICB/ICH/SAH",
    iddm = "IDDM",
    insomnia = "Insomnia",
    kidneyStones = "Kidney stones",
    tuberculosis = "Tuberculosis",
    ulcer = "Ulcer",
    uti = "UTI",
    ventricularFibrillation = "Ventricular fibrillation",
    liverDisease = "Liver disease",
    lupus = "Lupus",
    mi = "MI",
    migraines = "Migraines",
    mitralValveProlapse = "Mitral valve prolapse",
    mrsa = "MRSA",
    muscularDystrophy = "Muscular dystrophy",
    mva = "MVA",
    neuropathy = "Neuropathy",
    niddm = "NIDDM",
    obesity = "Obesity",
    osa = "Obstructive sleep apnea",
    osteoarthritis = "Osteoarthritis",
    osteomyelitis = "Osteomyelitis",
    osteoporosis = "Osteoporosis",
    pancreatitis = "Pancreatitis",
    pe = "PE",
    peritonitis = "Peritonitis",
    pleuralEffusion = "Pleural effusion",
    pneumonia = "Pneumonia",
    pulmonaryEdema = "Pulmonary Edema",
    pud = "PUD",
    pvd = "PVD",
    radiation = "Radiation",
    renalDisease = "Renal disease",
    rheumaticFever = "Rheumatic fever",
    rheumatoidArthritis = "Rheumatoid arthritis",
    sarcoidosis = "Sarcoidosis",
    schizophrenia = "Schizophrenia",
    seizureDisorder = "Seizure disorder",
    shingles = "Shingles",
    sickleCellAnemia = "Sickle Cell Anemia",
    vre = "VRE",
    wpw = "Wolff-Parkinson-White syndrome",
    noContraindications = "No General Recovery Contraindications",
    other = "Other",
}

export enum PastProceduresSurgicalHistory {
    aaaRepair = "AAA repair",
    aka = "AKA",
    amputation = "Amputation",
    angioplasty = "Angioplasty",
    aorticValveReplacement = "Aortic valve replacement",
    appendectomy = "Appendectomy",
    backSx = "Back Sx",
    biopsy = "Biopsy",
    bka = "BKA",
    bronchoscopy = "Bronchoscopy",
    cSection = "C-Section",
    cabg = "CABG",
    cardiacCatheterization = "Cardiac Catheterization",
    carpalTunnel = "Carpal Tunnel",
    cholecystectomy = "Cholecystectomy",
    colectomy = "Colectomy",
    colonoscopy = "Colonoscopy",
    craniectomy = "Craniectomy",
    craniotomy = "Craniotomy",
    endarterectomy = "Endarterectomy",
    esophagectomy = "Esophagectomy",
    exploratoryLaparotomy = "Exploratory Laparotomy",
    femoropoplitealBypass = "Femoropopliteal bypass",
    gastrectomy = "Gastrectomy",
    hemorrhoidectomy = "Hemorrhoidectomy",
    herniaRepair = "Hernia repair",
    hipSx = "Hip Sx",
    hysterectomy = "Hysterectomy",
    internalDefibrillatorPacemaker = "Internal Defibrillator/Pacemaker",
    kneeSx = "Knee Sx",
    lumbarLectomy = "Lumbar Lectomy",
    lobectomy = "Lobectomy",
    lumpectomy = "Lumpectomy",
    lymphadenectomy = "Lymphadenectomy",
    mastectomy = "Mastectomy",
    neckSx = "Neck Sx",
    nephrectomy = "Nephrectomy",
    orchiectomy = "Orchiectomy",
    orif = "ORIF",
    pegtubePlacement = "Pegtube placement",
    portPlacement = "Port placement",
    prostatectomy = "Prostatectomy",
    rotaryCuffSx = "Rotary Cuff Sx",
    shoulderSx = "Shoulder Sx",
    stentPlacements = "Stent placements",
    thoracentesis = "Thoracentesis",
    thoracotomy = "Thoracotomy",
    thyroidectomy = "Thyroidectomy",
    tonsillectomy = "Tonsillectomy",
    tracheotomy = "Tracheotomy",
    tubalLigation = "Tubal Ligation",
    vasectomy = "Vasectomy",
    other = "Other",
}

export enum Medications {
    abacavir = "Abacavir",
    abilify = "Abilify",
    accupril = "Accupril",
    acetaminophen = "Acetaminophen",
    acyclovir = "Acyclovir",
    adderall = "Adderall",
    advair = "Advair",
    advil = "Advil",
    albendazole = "Albendazole",
    albumin = "Albumin",
    albuterol = "Albuterol",
    aldactone = "Aldactone",
    aleve = "Aleve",
    allegra = "Allegra",
    allopurinol = "Allopurinol",
    altace = "Altace",
    amaryl = "Amaryl",
    ambien = "Ambien",
    amiodarone = "Amiodarone",
    ampicillin = "Ampicillin",
    amoxicillin = "Amoxicillin",
    ancef = "Ancef",
    aricept = "Aricept",
    asa = "ASA",
    atenolol = "Atenolol",
    ativan = "Ativan",
    atropine = "Atropine",
    atrovent = "Atrovent",
    augmentin = "Augmentin",
    avelox = "Avelox",
    mgso4 = "MgSO4",
    miralax = "Miralax",
    morphine = "Morphine",
    nahco3 = "NaHCO3",
    naproxen = "Naproxen",
    narcan = "Narcan",
    neosynephrine = "Neosynephrine",
    neurontin = "Neurontin",
    nexium = "Nexium",
    nimbex = "Nimbex",
    nitroglycerin = "Nitroglycerin",
    norcuron = "Norcuron",
    norvasc = "Norvasc",
    novolinR = "Novolin R",
    novolog = "Novolog",
    nystatin = "Nystatin",
    omega3 = "Omega 3",
    oxycodone = "Oxycodone",
    oxycontin = "Oxycontin",
    oxytocin = "Oxytocin",
    paxil = "Paxil",
    penciclovir = "Penciclovir",
    penicillin = "Penicillin",
    pentafuside = "Pentafuside",
    pepcid = "Pepcid",
    azithromycin = "Azithromycin",
    bactracin = "Bactracin",
    bactrim = "Bactrim",
    benadryl = "Benadryl",
    buspar = "Buspar",
    calcium = "Calcium",
    calciumCarbonate = "Calcium carbonate",
    cacl = "CaCl",
    calciumGluconate = "Calcium gluconate",
    capozide = "Capozide",
    captopril = "Captopril",
    cardene = "Cardene",
    cardizem = "Cardizem",
    carvedilol = "Carvedilol",
    celebrex = "Celebrex",
    cellcept = "Cellcept",
    cipro = "Cipro",
    ciprofloxacin = "Ciprofloxacin",
    claritin = "Claritin",
    clindamycin = "Clindamycin",
    clonazepam = "Clonazepam",
    codeine = "Codeine",
    cogentin = "Cogentin",
    colace = "Colace",
    combivent = "Combivent",
    coreg = "Coreg",
    coumadin = "Coumadin",
    cozaar = "Cozaar",
    crestor = "Crestor",
    percocet = "Percocet",
    phenergan = "Phenergan",
    pipercillin = "Pipercillin",
    plasmanate = "Plasmanate",
    plavix = "Plavix",
    pneumovax = "Pneumovax",
    pravastatin = "Pravastatin",
    prednisone = "Prednisone",
    prilosec = "Prilosec",
    protamine = "Protamine",
    potassium = "Potassium",
    prostat = "Prostat",
    protonix = "Protonix",
    prozac = "Prozac",
    quinidine = "Quinidine",
    ramipril = "Ramipril",
    reglan = "Reglan",
    remeron = "Remeron",
    requip = "Requip",
    restoril = "Restoril",
    retrovir = "Retrovir",
    risperdal = "Risperdal",
    robinul = "Robinul",
    robitussin = "Robitussin",
    rocephin = "Rocephin",
    cymbalta = "Cymbalta",
    decadron = "Decadron",
    demerol = "Demerol",
    depakote = "Depakote",
    dexamethasone = "Dexamethasone",
    dextran = "Dextran",
    dextrose = "Dextrose",
    diazepam = "Diazepam",
    diflucan = "Diflucan",
    digoxin = "Digoxin",
    dilantin = "Dilantin",
    dilaudid = "Dilaudid",
    diprivan = "Diprivan",
    dobutamine = "Dobutamine",
    docusate = "Docusate",
    dopamine = "Dopamine",
    dulcolax = "Dulcolax",
    effexor = "Effexor",
    elavil = "Elavil",
    enfuvirtide = "Enfuvirtide",
    entecavir = "Entecavir",
    epinephrine = "Epinephrine",
    erythromycin = "Erythromycin",
    etomidate = "Etomidate",
    famciclovir = "Famciclovir",
    fentanyl = "Fentanyl",
    fishOil = "Fish Oil",
    flagyl = "Flagyl",
    fleet = "Fleet",
    flexeril = "Flexeril",
    scopolamine = "Scopolamine",
    senna = "Senna",
    serevent = "Serevent",
    seroquel = "Seroquel",
    silverNitrate = "Silver Nitrate",
    simvastatin = "Simvastatin",
    singulair = "Singulair",
    sodiumPhosphate = "Sodium Phosphate",
    soluCortef = "Solu-Cortef",
    soluMedrol = "Solu-Medrol",
    spiriva = "Spiriva",
    succinylcholine = "Succinylcholine",
    sudafed = "Sudafed",
    synthroid = "Synthroid",
    tagamet = "Tagamet",
    tapazole = "Tapazole",
    taxol = "Taxol",
    tegretol = "Tegretol",
    temazepam = "Temazepam",
    thiamine = "Thiamine",
    tobramycin = "Tobramycin",
    toprol = "Toprol",
    toradol = "Toradol",
    trazodone = "Trazodone",
    tricor = "Tricor",
    flomax = "Flomax",
    flovent = "Flovent",
    folicAcid = "Folic Acid",
    fuzeon = "Fuzeon",
    gentamicine = "Gentamicine",
    glucagon = "Glucagon",
    glucophage = "Glucophage",
    glucose = "Glucose",
    guaifenesin = "Guaifenesin",
    haldol = "Haldol",
    heparin = "Heparin",
    hespan = "Hespan",
    humalog = "Humalog",
    humulin = "Humulin",
    hctz = "HCTZ",
    hydralazine = "Hydralazine",
    hydrocodone = "Hydrocodone",
    ibuprofen = "Ibuprofen",
    ifosfamide = "Ifosfamide",
    imdur = "Imdur",
    imodium = "Imodium",
    inapsine = "Inapsine",
    inderal = "Inderal",
    insulin = "Insulin",
    interferon = "Interferon",
    iron = "Iron",
    isosorbide = "Isosorbide",
    kci = "KCI",
    keppra = "Keppra",
    klorCon = "Klor-Con",
    tromethamine = "Tromethamine",
    tuberculin = "Tuberculin",
    ultram = "Ultram",
    unasyn = "Unasyn",
    valtrex = "Valtrex",
    vancomycin = "Vancomycin",
    vaprisol = "Vaprisol",
    vasopressin = "Vasopressin",
    vasotec = "Vasotec",
    verapamil = "Verapamil",
    versed = "Versed",
    vistaril = "Vistaril",
    vitamin = "Vitamin",
    vivitrol = "Vivitrol",
    wellbutrin = "Wellbutrin",
    xanax = "Xanax",
    zantac = "Zantac",
    zemuron = "Zemuron",
    zinc = "Zinc",
    zincOxide = "Zinc Oxide",
    zocor = "Zocor",
    zofran = "Zofran",
    zoloft = "Zoloft",
    zosyn = "Zosyn",
    labetalol = "Labetalol",
    lactulose = "Lactulose",
    lamisil = "Lamisil",
    lanoxin = "Lanoxin",
    lantus = "Lantus",
    lasix = "Lasix",
    levaquin = "Levaquin",
    levofloxacin = "Levofloxacin",
    levophed = "Levophed",
    levothroid = "Levothroid",
    levothyroxine = "Levothyroxine",
    levoxyl = "Levoxyl",
    lexapro = "Lexapro",
    librium = "Librium",
    lidocaine = "Lidocaine",
    lipitor = "Lipitor",
    lisinopril = "Lisinopril",
    lithium = "Lithium",
    lopressor = "Lopressor",
    lortab = "Lortab",
    lovastatin = "Lovastatin",
    lovenox = "Lovenox",
    magnesium = "Magnesium",
    mannitol = "Mannitol",
    megace = "Megace",
    mesna = "Mesna",
    methadone = "Methadone",
    methamphetamine = "Methamphetamine",
    metoprolol = "Metoprolol",
    midazolamHydrochloride = "Midazolam Hydrochloride",
    other = "Other",
}
